// extracted by mini-css-extract-plugin
export default {"back":"styles_back__7R8m+","checked":"styles_checked__Qr40T"};